const WorkspaceShellPage = () => import('./Index.vue');

export const routes = [
  {
    path: 'workspace/:workspacePath(.*)*',
    alias: ['workspace'],
    name: 'workspace_shell',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: WorkspaceShellPage,
  },
];
